export const pctChange = (curr, prev) => (prev > 0 && curr != null ? Math.round(((curr - prev) / prev) * 100) : null);

const sum = (arr, key) => arr.reduce((a, d) => a + (Number(d[key]) || 0), 0);

// Confronta gli ultimi `n` punti con gli `n` precedenti
export function splitChange(series, key, n = 7) {
  if (!series || series.length < n * 2) return null;
  const last = series.slice(-n), prev = series.slice(-n * 2, -n);
  return pctChange(sum(last, key), sum(prev, key));
}

export function trendTitle({ subject, pct, neutral, period = "questa settimana", upWord = "è salita", downWord = "è scesa", stableWord = "è stabile" }) {
  if (pct == null) return neutral;
  if (Math.abs(pct) < 2) return `${subject} ${stableWord} ${period}`;
  return `${subject} ${pct > 0 ? upWord : downWord} del ${Math.abs(pct)}% ${period}`;
}
